<script lang="ts" setup>
defineProps({
  isSelected: {
    type: Boolean,
    default: false,
  },
  noPointer: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    :class="{
      'option-select-card-block--selected': isSelected,
      'cursor-pointer hover:!border-black-20': !noPointer,
    }"
    class="option-select-card-block"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.option-select-card-block {
  display: flex;
  gap: 12px;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 12px;
  background-color: $black-5;
  transition: all 0.2s;

  &--selected {
    border-color: $black-80 !important;
  }

  @include screen-sm {
    padding: 16px;
  }
}
</style>
